import React from "react";
import { connect } from "react-redux";
import { Modal, Input, message, Icon, Button, Form } from 'antd';

import LayoutWrapper from '../../layouts/LayoutWrapper';
import DynamicForm from "../../components/frame/DynamicForm";
import DynamicTable from "../../components/frame/DynamicTable";

import DynamicFilter from "../../components/frame/DynamicFilter";
import DynamicButton from "../../components/frame/DynamicButton";
import ReactAbstract from "../../components/abstract/React.abstract";
import SalaryAdditonService from "../../services/SalaryAllowance/salary-addition-service";
import salaryLedgerService
	from "../../services/SalaryAllowance/salary-ledger-service";
import { fetchDepartmentsList } from '../../actions/department-structure-actions';
import {fetchEmployeesList} from '../../actions/employee-management-actions';

class SalaryAddition extends ReactAbstract {

   

    initReload = true
    dataMode = 0 
    deleteRowSelection = false
    moduleName = "salaryAllowance"
    childModuleName = "salaryLedger"

    state = {
        currentModalStatus: false,
        currentIndex: null,
        currentData: {},
        currentDataStatus: "unload",
        importModal: false,
        filters: {
            start_time: null,
            end_time: null
        },
        data: [],
        dataStatus: "unload",
    }

    actions = {
        selectAction: SalaryAdditonService.select,
        createAction: SalaryAdditonService.create,
        updateAction: SalaryAdditonService.update,
        deleteAction: SalaryAdditonService.delete,
        //exportAction: OvertimeApprovalService.exportOvertimeApproval
    }

    headerColumn = [{
        title: "新增",
        icon: "plus-circle-o",
        click:  () =>{this.createData()}
    },{
        title: "删除",
        icon: "delete",
        click: () =>{this.publicDelete()}
    },
    	{
		title: "导入",
		icon: "cloud-upload-o",
		click: this.openImportModal.bind(this)
	}, 
       
    ]
 
    filterColumn = [{
        type: "person",
        label: "请输入工号或姓名"
    },

    {
        type: "department"
    }, {
        type: "date",
        label: "年月",
        key: "year_month",
        format:"YYYY-MM"
    }
    ]

    tableColumn = [{
        title: '工号',
        dataIndex: 'job_number',
        key: 'job_number',
        className: 'table-global-head-small'
    }, {
        title: '证件姓名',
        dataIndex: 'real_name',
        key: 'real_name',
        className: 'table-global-head-small'
    }, {
        title: '年月',
        dataIndex: 'year_month',
        key: 'year_month',
        className: 'table-global-head-small'
    },{
        title: '其他',
        dataIndex: 'invoice_tax_deduct',
        key: 'invoice_tax_deduct',
        className: 'table-global-head-short'
    }, {
        title: '税后扣款',
        dataIndex: 'post_tax_deduct',
        key: 'post_tax_deduct',
        className: 'table-global-head-short'
    },{
        title: '其他补贴',
        dataIndex: 'subsidy',
        key: 'subsidy',
        className: 'table-global-head-short'
    },  {
        title: '课时费',
        dataIndex: 'class_hour_fee',
        key: 'class_hour_fee',
        className: 'table-global-head-short'
    }, {
        title: '子女教育支出',
        dataIndex: 'children_education',
        key: 'children_education',
        className: 'table-global-head-6x'
    }, {
        title: '继续教育支出',
        dataIndex: 'adult_education',
        key: 'adult_education',
        className: 'table-global-head-6x'
    }, {
        title: '住房贷款利息支出',
        dataIndex: 'home_loan_interest',
        key: 'home_loan_interest',
        className: 'table-global-head-8x'
    }, {
        title: '住房租金支出',
        dataIndex: 'housing_rents',
        key: 'housing_rents',
        className: 'table-global-head-6x'
    }, {
        title: '赡养老人支出',
        dataIndex: 'support_the_old',
        key: 'support_the_old',
        className: 'table-global-head-6x'
    }, {
        title: '操作',
        dataIndex: 'actions',
        key: 'actions',
        className: 'table-global-head-small',
        render: (text, record, index) => (
            <DynamicButton column={this.buttonColumn(text, record, index)}
                module={this.childModuleName}
                access={this.props.access} />
        )
    }
    ]
    buttonColumn = (text, record, index) => [{
        size: "small",
        type: "default",
        icon: "edit",
        title: "修改",
        access: "u_value",
        click: this.updateData.bind(this, record, index)
    }
    ]
    formColumn =()=> [{
        label: "员工姓名",
        key: "employee_id",
        valueKey: "real_name",
        type: "person",
        valueWidth: "300px",
        valueWidthSelect: "276px",
        rules: {
            disabled: null !== this.state.currentIndex
        },
       
    }, 
    {
        label: "年月",
        key: "year_month",
        type: "date",
        required: true,
        rules:{
            disabled: null !== this.state.currentIndex,
            format:"YYYY-MM"
        }
    }, 
    {
		label: "其他",
		key: "invoice_tax_deduct",
		type: "number",
		required: false
	},	{
		label: "税后扣款",
		key: "post_tax_deduct",
		type: "number",
		required: false
	}, {
		label: "其他补贴",
		key: "subsidy",
		type: "number",
		required: false
	}, {
		label: "课时费",
		key: "class_hour_fee",
		type: "number",
		required: false
	},	{
		label: "子女教育支出",
		key: "children_education",
		type: "number",
		required: false
	},
	{
		label: "继续教育支出",
		key: "adult_education",
		type: "number",
		required: false
	},
	{
		label: "住房贷款利息支出",
		key: "home_loan_interest",
		type: "number",
		required: false
	},
	{
		label: "住房租金支出",
		key: "housing_rents",
		type: "number",
		required: false
	},
	{
		label: "赡养老人支出",
		key: "support_the_old",
		type: "number",
		required: false
	}
    ]
    createData = () => this.setState({
		currentData: {},
		currentModalStatus: true,
		currentDataStatus: "loaded",
		currentIndex: null
	})
    updateData = (record, index) => this.setState({
		currentData: this.dataSource().data.Data[index],
		currentModalStatus: true,
		currentDataStatus: "loaded",
		currentIndex: index
    })
    openImportModal() {
		this.setState({ importModal: true });
    }
    closeImportModal() {
		this.setState({ importModal: false });
    }
    setUploadedFile = event => {
		this.setState({ uploadedFile: event.target.files[0] });
	}
    downloadTemplate = () => {
		let ref = Modal.info({ content: "正在准备需要下载的模板" });
		salaryLedgerService.downloadAdditionTemplate(res => {
			ref.destroy();
			if (res.data.Success) {
				window.open(res.data.Message);
			}
		});
	}
	import = () => {
		if (this.state.uploadedFile) {
			let ref = Modal.info({ content: "正在导入文件, 请稍后..." });
			let formData = new FormData();
			formData.append("uploadedFile", this.state.uploadedFile);
			SalaryAdditonService.import(formData, res => {
				ref.destroy();
				if (res.data.Success) {
					message.success('导入文件成功，' + res.data.Message, 4);
					this.setState({
						importModal: false,
						dataStatus: "unload"
					});
					this.publicSelect();
					if (res.data.Object) {
						window.open(res.data.Object);
					}
				} else {
					message.error("导入文件失败, " + res.data.Errors[0], 4)
				}
			}, err => message.error("导入文件失败", 4));
		} else {
			message.error("请选择需要导入的文件", 4);
		}
	}
    publicSubmit = () => {
		this.props.form.validateFields((err, values) => {
			if (!err) {
				Object.keys(values).map(item=>{
					console.log(typeof values[item])
				})
				console.log(values)
				const currentData = {
					...this.state.currentData,
                    ...values,
                    year_month:values.year_month?values.year_month.format('YYYY-MM-DD'):null,
				}
				const callee = null === this.state.currentIndex ?
					this.publicCreate : this.publicUpdate;
				callee(currentData);
			}
		})
	}

    customComponentWillMount() {
        this.props.fetchDepartmentsList()
    }


    render() {
        return (
            <div className="app-module-item">
                <div className="app-module-header">
                    <DynamicButton column={this.headerColumn}
                        module={"AnnouncementList"}
                        access={this.props.access} />
                </div>
                <div className="app-module-header">
                    <DynamicFilter column={this.filterColumn}
                        departmentsList={this.props.departmentStructure.departmentsList}
                        value={this.dataSource().filters}
                        setFilter={this.publicChange} />
                </div>
                <Modal width="1000px"
                maskClosable={false}
                    visible={this.state.currentModalStatus}
                    title={null === this.state.currentIndex?"新增其他数据":"修改其他数据"}
                    destroyOnClose={true}
                    onCancel={this.toggleCurrentModal}
                    onOk={this.publicSubmit} >
                    <DynamicForm column={this.formColumn}
                        form={this.props.form}
                        selectEmployee={this.props.fetchEmployeesList}
                        employees={this.props.employeeManagement.employeeList}
                        loadStatus={this.state.currentDataStatus}
                        dataSource={this.state.currentData} />
                </Modal>
                <Modal width="900px"
					visible={this.state.importModal}
					title="导入数据"
					destroyOnClose={true}
					onCancel={this.closeImportModal.bind(this)}
					footer={<Button type="back" onClick={this.closeImportModal.bind(this)}>关闭</Button>}>
					<div style={{ textAlign: "center", margin: "20px 0px 20px" }}>
						<div>
							<Button type="primary" onClick={this.downloadTemplate}>
								<Icon type="cloud-download-o" />
								<span>下载模板</span>
							</Button>
						</div>
						<div style={{ marginTop: "40px" }}>
							<div>导入文件</div>
							<Input type="file" style={{ height: "38px" }} onChange={this.setUploadedFile} />
							<Button type="primary" style={{ marginTop: "20px" }} onClick={this.import}>
								<Icon type="cloud-upload-o" />
								<span>开始导入</span>
							</Button>
						</div>
					</div>
				</Modal>
                <div>
                    <DynamicTable column={this.tableColumn}
                        dataStatus={this.dataSource().dataStatus}
                        dataSource={this.dataSource().data.Data}
                        pagination={{
                            total: this.dataSource().data.Total,
                            pageSize: this.dataSource().data.PageSize+1,
                            current: this.dataSource().filters.page
                        }}
                        rowSelection={this.rowSelection}
                        setPageFilter={this.publicChange} />
                </div>
            </div>
        )
    }
}

SalaryAddition = Form.create()(SalaryAddition);

const mapStateToProps = state => {
    return {
        departmentStructure: state.departmentStructure,
        employeeManagement: state.employeeManagement,
    }
}

const mapDispatchToProps = {
    fetchDepartmentsList,
    fetchEmployeesList,
}

SalaryAddition = connect(mapStateToProps, mapDispatchToProps)(SalaryAddition);

export default LayoutWrapper(SalaryAddition);


// WEBPACK FOOTER //
// ./src/routes/SalaryAllowance/SalaryAddition.js